import { render } from "./text_panel.vue?vue&type=template&id=44be7bac&scoped=true"
import script from "./text_panel.vue?vue&type=script&lang=js"
export * from "./text_panel.vue?vue&type=script&lang=js"

import "./text_panel.vue?vue&type=style&index=0&id=44be7bac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44be7bac"]])

export default __exports__